<script setup lang="ts">
import { computed } from 'vue';
import InputTimesForm from "@/components/OperationOfficeForms/InputTimesForm.vue"
import i18n from '@/lang/i18n';

const emits = defineEmits(['update:modelValue']);
const props = defineProps<{
  windowInnerWidth: number,
  modelValue: {
    ittenko_before_leaving: {
      hours: number,
      minutes: number
    },
    ittenko_after_returning: {
      hours: number,
      minutes: number
    }
  },
  errors: {
    [key: string]: string[] | undefined
  }
}>();

const maxlengths = {
  hours: 1,
  minutes: 2
}


const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", {
      value
    });
  },
});
</script>
<template>
  <v-row class="radio-form pl-4 pr-3 mb-2">
    <v-col v-show="windowInnerWidth < 800" cols="4">
      <h6 class="pt-2 pl-4" style="font-weight: bold">{{ i18n.global.t('pages.operationOffices.form.ittenko.acquisitionTime') }}</h6>
    </v-col>
  </v-row>
  <v-row class="pl-4 pr-3 mb-2">
    <v-col v-show="windowInnerWidth > 800" cols="2">
      <h6 class="pt-2 pl-4" style="font-weight: bold">{{ i18n.global.t('pages.operationOffices.form.ittenko.acquisitionTime') }}</h6>
    </v-col>
    <InputTimesForm
      :title="i18n.global.t('pages.operationOffices.form.ittenko.beforeLeaving')"
      v-model="modelValue.ittenko_before_leaving"
      :windowInnerWidth="windowInnerWidth"
      :maxlength="maxlengths"
      :errors="{
        hours: props.errors.ittenko_before_leaving_hours ?? [],
        minutes: props.errors.ittenko_before_leaving_minutes ?? []
      }"
    />
  </v-row>
  <v-row class="pl-4 pr-3 mb-4">
    <v-col v-show="windowInnerWidth > 800" cols="2"></v-col>
    <InputTimesForm
      :title="i18n.global.t('pages.operationOffices.form.ittenko.afterReturning')"
      v-model="modelValue.ittenko_after_returning"
      :windowInnerWidth="windowInnerWidth"
      :maxlength="maxlengths"
      :errors="{
        hours: props.errors.ittenko_after_returning_hours ?? [],
        minutes: props.errors.ittenko_after_returning_minutes ?? []
      }"
    />
  </v-row>
</template>
<style scoped>
.radio-form {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
</style>
